import React from 'react';

import EyeShow from '@swf/core/assets/icons/eye-show.svg';
import Eye from '@swf/core/assets/icons/eye.svg';

import type { Props } from './Input';
import Input from './Input';

class NumericPassword extends React.PureComponent<Props> {
  state: { type: Props['type'] } = { type: 'password' };

  isPassword() {
    return this.state.type === 'password';
  }

  toggleType() {
    this.setState({ type: this.isPassword() ? 'text' : 'password' });
  }

  numsOnly = (value: string) => value.replace(/[^\d]/g, '');

  render() {
    const Icon = this.isPassword() ? Eye : EyeShow;

    return (
      <Input
        {...this.props}
        showValidationTick={false}
        type={this.state.type}
        parse={this.numsOnly}
        numericKeyboard
      >
        <Icon onClick={() => this.toggleType()} />
      </Input>
    );
  }
}

export default NumericPassword;
